import { useMemo, useState } from 'react';
import { sentBetween, type DayRange } from '@/lib/automation-replies';
import type { EscalationOutcome } from '@/services/escalation-log.service';

export type EscalationOutcomeFilter = 'all' | EscalationOutcome;

/** The outcome and dates the log is narrowed to; kept by the Logs page so its header can show them. */
export function useEscalationLogFilters() {
	const [outcome, setOutcome] = useState<EscalationOutcomeFilter>('all');
	const [days, setDays] = useState<DayRange>({});
	// Memoised so each query keeps one key until the filters change.
	const range = useMemo(() => sentBetween(days), [days]);
	return { outcome, setOutcome, days, setDays, range };
}

export type EscalationLogFilters = ReturnType<typeof useEscalationLogFilters>;
